import React from "react";
import { useAlert } from "../../Context/AlertContext";
import styles from "./styles/notification.module.css"
function Notification() {
    const alert = useAlert()
    return (
        alert.alert
        ?
        <div className={styles.main}> 
            <div className={styles.submain}>
                <div style={{position:"relative"}}>
                <div className={styles.title}>{alert.alert[0]}</div>
                <div className={styles.subtitle}>{alert.alert[1]}</div>
                <div onClick={()=>{alert.unpush(); console.log(alert)}} className={styles.close}></div>
                </div>
            </div>
        </div>
        : null
    );
}

export default Notification;
